export default __webpack_public_path__ + "static/media/NBII_co_branding_in_pdf-page-001.e695947d.jpg";